import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import '../nd/nd.css';
import EquipmentTemplateForm from './EquipmentTemplateForm';
import useNDData from '../nd/useNDData';

type props = {
  templateId: string;
  handleNextStep: Function;
  registerStepActions?: (actions: {
    onNext?: (() => void) | null;
    nextDisabled?: boolean;
  }) => void;
};

function EquipmentTemplatePanel({
  templateId,
  handleNextStep,
  registerStepActions,
}: props) {
  const { formatMessage } = useIntl();
  const projectId = useSelector((state: any) => state.mainFrame.projectId);
  const { apOrTemplate, equipmentChoices } = useNDData(
    projectId,
    true,
    templateId
  );
  if (apOrTemplate != null && equipmentChoices != null) {
    return (
      <EquipmentTemplateForm
        projectId={projectId}
        choices={equipmentChoices}
        template={apOrTemplate}
        formatMessage={formatMessage}
        handleNextStep={handleNextStep}
        registerStepActions={registerStepActions}
      ></EquipmentTemplateForm>
    );
  }
  return <Loader active />;
}

export default EquipmentTemplatePanel;
